export const getUser = () => {
  const user = localStorage.getItem("userDetails");
  return user ? JSON.parse(user) : null;
};

export const getPermissions = () => {
  const user = getUser();
  return user?.permissions || [];
};

export const hasPermission = (perm) => {
  return getPermissions().includes(perm);
};

export const getFieldAccess = () => {
  const user = getUser();
  return user?.fieldsAccess || [];
};

export const canAccessField = (fieldName) => {
  return getFieldAccess().includes(fieldName);
};

export const getUserRoles = () => {
  const user = getUser();
  return user?.role || []; // array of role names like ["Super Admin", ...]
};
